/* eslint-disable class-methods-use-this */

export interface AddToBasketResponse {
	ProductTitle: string | null;
	ProductImage: string | null;
	ProductPrice: number;
	ProductDiscount: number;
	ProductPriceExVat: number;
	TotalNumberOfItems: number;
	BasketTotal: number;
	BasketTotalExVat: number;
	BasketTotalVatAmount: number;
	BasketDiscountTotal: number;
	RedirectLocation: string;
	DisplayProductPrice: string;
	DisplayBasketTotal: string;
	WasPrice: number;
	LoyaltyPointsTotal: number;
	LoyaltyCardType: string | null;
}

export class BasketService {
	isReadOnly = false; // TODO: Should be a private property, but jest doesn't like it

	constructor() {
		this.isReadOnly = false;
	}

	async addToBasket(url: string): Promise<AddToBasketResponse | void> {
		if (this.isReadOnly) {
			return Promise.resolve();
		}

		try {
			const response = await fetch(url, {
				method: 'POST',
				headers: {
					'content-type': 'application/json',
				},
				credentials: 'include',
			});

			if (!response.ok) {
				return Promise.reject(response.statusText);
			}

			const responseData: AddToBasketResponse = await response.json();

			return Promise.resolve(responseData);
		} catch (error) {
			return Promise.reject(error);
		}
	}

	updateHeaderBasketCount(count: number): void {
		if (count <= 0) {
			return;
		}

		const headerBasketCount = document.getElementById('basketCount');

		if (headerBasketCount) {
			headerBasketCount.classList.add('basketWithItems');
			headerBasketCount.classList.remove('noItems');
			headerBasketCount.textContent = `${count}`;
		}
	}
}

export default BasketService;
